import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

const DarkTheme: ThemeTypes = {
  name: 'Dark',
  dark: true,
  colors: {
    primary: '#1a6b6c',
    secondary: '#d88a2b',
    info: '#05d1e0',
    success: '#00e676',
    accent: '#FFB3A1',
    warning: '#ffca28',
    error: '#f6685e',
    lightprimary: '#1a1a1a',
    lightsecondary: '#d87a2b',
    lightsuccess: '#3a7d5d',
    lighterror: '#fbc4c4',
    lightwarning: '#fff9c4',
    darkprimary: '#166b6c',
    darksecondary: '#d87a2b',
    darkText: '#e0e4f5',
    lightText: '#e0e8f5',
    borderLight: '#808a9a',
    inputBorder: '#9faabd',
    containerBg: '#1a1a1a',
    surface: '#2a2a2a',
    background: '#2a2a2a',
    'on-surface-variant': '#1a1a1a',
    facebook: '#4a77c2',
    twitter: '#29b2f2',
    linkedin: '#1e86b8',
    gray100: '#1a1a1a',
    primary200: '#b0d4e0',
    secondary200: '#f3e1b1'
  }
};

export { DarkTheme };
